import QueryString from "qs";
import BlogDetails from "@/Components/pages/blog/detail";
import HocHead from "@/Components/HigherOrderComponent/HocHead";
import Page410 from "@/Components/410/410";
import { getArticleRoutePrefix } from "@/utils/common";
import { GetServerSideProps, NextPage } from "next";
// import Whitepaper from "@/Components/pages/blog/whitepaper";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

const page410 = [
  "digital-transformation-in-aviation-a-guide-to-choosing-the-best-software-for-your-business",
  "trends-in-digital-transformation-in-higher-education",
  "offshore-software-development",
  "metrics-to-measure-developers-performance",
];

interface BlogDetailProps {
  apiResData: any;
  slug: string;
  status: number;
  isNew: boolean;
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const slug = ctx?.params?.slug as string;

  // Properly setting 410 status
  if (page410.includes(slug)) {
    ctx.res.statusCode = 410;
    return {
      props: {
        apiResData: {},
        slug,
        status: 410,
      },
    };
  }

  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=18000, stale-while-revalidate=59",
    );
  }

  if (slug === "blog" || slug === "newsroom") {
    return {
      redirect: {
        permanent: true,
        destination: `/${slug}`,
      },
    };
  }

  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep,6",
    },
    {
      encodeValuesOnly: false,
    },
  );
  apiRes = await fetch(`${baseUrl}articles?${decodeURIComponent(query)}`);
  apiResData = await apiRes.json();

  if (apiResData?.data?.length === 0) {
    return {
      notFound: true,
    };
  }

  // Redirect to the canonical route prefix (blog/whitepaper/newsroom) to
  // avoid the same article being reachable/indexable under multiple URLs.
  const canonicalPrefix = getArticleRoutePrefix(apiResData?.data?.[0]?.attributes);
  if (canonicalPrefix !== "blog") {
    return {
      redirect: {
        permanent: true,
        destination: `/${canonicalPrefix}/${slug}`,
      },
    };
  }

  isNew = apiResData?.data[0]?.attributes?.design === "new";
  return {
    props: {
      apiResData,
      slug,
      status: 200,
      isNew,
    },
  };
};

const BlogDetail: NextPage<BlogDetailProps> = ({ apiResData, status }) => {
  const seo = apiResData.data[0]?.attributes.seo;
  const data = apiResData.data[0]?.attributes;

  //BLOG THEME

  return (
    <div id="root">
      {seo && (
        <HocHead seo={seo}>
          <meta
            data-head="tezjs"
            property="article:published_time"
            content={data.publish_at}
          />
          <meta
            data-head="tezjs"
            property="article:modified_time"
            content={data.updatedAt}
          />
          <meta data-head="tezjs" property="og:type" content="article" />
          <meta data-head="tezjs" property="og:locale" content="en_US" />
          <meta data-head="tezjs" property="og:site_name" content="TRooTech" />
          <meta
            name="author"
            content={data.authors.data[0].attributes.fullname}
          />
        </HocHead>
      )}

      {status == 410 ? (
        <Page410 />
      ) : (
        <div>
          <BlogDetails blocks={apiResData} />
        </div>
      )}
    </div>
  );
};

export default BlogDetail;
